import { createPopper } from '@popperjs/core';
import { bind } from 'lodash-es';

let props = {
  arrow: true,
  fade: true,
  event: 'click',
}
let options = {
  placement: 'auto',
  modifiers: [
    {
      name: 'arrow',
      options: {
        element: '[data-popper-arrow]'
      },
    },
  ],

}

export default {
  inserted(el, binding) {
    binding.value = { ...props, ...binding.value }
    el.showPopover = () => showPopover(el, binding);
    setupEventListeners(el, binding);
  },
  unbind(el) {
    if (el.popoverEl) {
      el.popoverEl.remove();
    }
  },
};
function setupEventListeners(el, binding) {
  if (binding.value.event) {
    if (binding.value.event === 'hover') {
      el.addEventListener('mouseenter', el.showPopover);
      el.addEventListener('mouseleave', () => {
        if (el.popoverEl) {
          el.popoverEl.classList.remove('show');
          el.popoverEl.remove();
        }
      });
    } else if (binding.value.event === 'click') {
      el.addEventListener('click', () => {
        if (!el.popoverEl) {
          el.showPopover();
        } else {
          el.popoverEl.classList.toggle('show');
          if (!el.popoverEl.classList.contains('show')) {
            el.popoverEl.remove();
          } else {
            el.showPopover();
          }
        }
      });
    } else if (binding.value.event === 'focus') {
      el.addEventListener('focus', el.showPopover);
      el.addEventListener('blur', () => {
        if (el.popoverEl) {
          el.popoverEl.classList.remove('show');
          el.popoverEl.remove();

        }
      });
    }
  }
}
function createPopperInstance(el, binding) {
  return createPopper(el, el.popoverEl, options);
}
function showPopover(el, binding) {
  el.popoverEl = document.querySelector(binding.value.popoverComponentSelector);

  if (!el.popoverEl) {
    makePopover(el, binding);
  }
  // update header and body
  updatePopover(el, binding);
  // createPopperInstance
  if (el.popperInstance) el.popperInstance.destroy();

  let popoverInstance = createPopperInstance(el, binding)
  // determine when placement changes

  el.popperInstance = popoverInstance;
  el.popoverEl.classList.add('show');

}

function makePopover(el, binding) {
  var container = document.body;
  var placement = options.placement.replace('left', 'start').replace('right', 'end');

  if (binding.value.container) {
    if (binding.value.container === 'parent') {
      container = el.parentElement;
    }
  }
  el.popoverEl = document.createElement('div');
  el.popoverEl.classList.add('popover');
  el.popoverEl.classList.add('bs-popover-auto');
  el.popoverEl.classList.add('bs-popover-' + placement);
  el.popoverEl.classList.add('fade');
  el.popoverEl.setAttribute('role', 'tooltip');
  if (binding.value.arrow) {
    var arrow = document.createElement('div');
    arrow.setAttribute('data-popper-arrow', '');
    arrow.classList.add('popover-arrow');
    el.popoverEl.appendChild(arrow);
  }

  if (binding.value.title) {
    var popoverHeader = document.createElement('div');
    popoverHeader.classList.add('popover-header');
    el.popoverEl.appendChild(popoverHeader);
  }
  var popoverBody = document.createElement('div');
  popoverBody.classList.add('popover-body');
  el.popoverEl.appendChild(popoverBody);

  container.appendChild(el.popoverEl);
}

function updatePopover(el, binding) {
  var header = el.popoverEl.querySelector('.popover-header');
  if (header) { header.innerHTML = binding.value.title; }
  var body = el.popoverEl.querySelector('.popover-body');
  if (body) { body.innerHTML = (binding.value.html ?? binding.value.body); }
}